import { CountDestinationsResponse } from '@/core/domain/count-destinations/models/count-destinations.model';
import { GetCountDestinationsUseCase } from '@/core/domain/count-destinations/usecases/getCountDestinations.usecase';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'fe-destination-locations',
    templateUrl: './destination-locations.component.html',
    styleUrls: ['./destination-locations.component.scss'],
})
export class DestinationLocationsComponent implements OnInit {
    public countDestinations: CountDestinationsResponse | null = null;

    isContainerVisible = false;

    constructor(
        private readonly getCountDestinationsUseCase: GetCountDestinationsUseCase,
    ) {}

    ngOnInit(): void {
        this.getCountDestinations();
    }

    getCountDestinations(): void {
        this.getCountDestinationsUseCase
            .execute()
            .subscribe((countDestinations) => {
                this.countDestinations = countDestinations;
            });
    }

    toggleContainer() {
        this.isContainerVisible = !this.isContainerVisible;
    }
}
